import React from "react";

import get from "lodash/get";
import moment from "moment/min/moment-with-locales.min";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locals/constants";

const Component = ({ folder }) => {
  const { t } = useTranslation(NAME_SPACES.HOME, { keyPrefix: "RENDEZVOUS" });

  return (
    <div className={"rendezvous-confirm"}>
      <p className={"title"}>{t("TITLE")}</p>
      <div>
        <p className={"description"}>
          {`${t("DESCRIPTION", {
            day: moment(folder?.date).format("dddd D MMMM"),
            hour: `${moment(
              get(folder, "interval.start"),
              "HH:mm:ss.SSS",
            ).format("HH")}H - ${moment(
              get(folder, "interval.end"),
              "HH:mm:ss.SSS",
            ).format("HH")}H`,
          })} `}
        </p>
      </div>
    </div>
  );
};

Component.propTypes = {
  folder: PropTypes.shape({
    date: PropTypes.string,
    interval: PropTypes.shape({
      start: PropTypes.string,
      end: PropTypes.string,
    }),
  }),
};
export default Component;
